<div *ngIf="isLoading" class="fullscreen-loader">
    <div class="loader"></div>
  </div>
  